document.addEventListener("DOMContentLoaded", function () {
  var modal = document.getElementById("upsellModal");
  var openModalBtn = document.getElementById("openUpsellModalBtn");
  var closeModalBtn = document.getElementById("closeModalBtn");
  
  // Close the modal if the background is clicked
  window.onclick = function(event) {
      if (event.target == modal) {
          modal.style.display = "none";
      }
  }
});
document.addEventListener("click", function (e) {
  const btn = e.target.closest("#product-add-to-cart, [data-btn-addToCart-upsell]");
  if (!btn) return;

  e.preventDefault();
  console.log("✅ Intercepted Add to Cart click");
  openUpsellModel();
}, true);

// Open the modal
// TBS 2026-10-21: show immediately (was 2s setTimeout), de-dupe the double call
// (capture listener + inline onclick), and publish the decision in
// window.__tbsUpsellDecision so theme.js opens the SessionFlow drawer only after close.
function openUpsellModel() {
  var modal = document.getElementById("upsellModal");
  var now = Date.now();
  var prev = window.__tbsUpsellDecision;
  if (prev && now - prev.at < 800) return;
  var decision = { at: now, resolved: false, show: false };
  window.__tbsUpsellDecision = decision;
  var refer = $("#upsellsetvaluerefer").val();
  if (!modal || !refer) { decision.resolved = true; return; }
  jQuery.getJSON('/cart.js', function(cart) {
    var handles = (cart && cart.items ? cart.items : []).map(function (i) { return i.handle; });
    $("#upsellsetvalue").val(handles.join(",") + ",");
    decision.show = handles.indexOf(refer) === -1;
    decision.resolved = true;
    if (decision.show) {
      $(".hs-popup-cart-sp-load").removeClass("hs-active");
      modal.style.display = "block";
    }
  }).fail(function () { decision.resolved = true; });
}
// Open the modal
function closeUpsellModel() {
  var modal = document.getElementById("upsellModal");
  var openModalBtn = document.getElementById("openUpsellModalBtn");
  var closeModalBtn = document.getElementById("closeModalBtn");
  modal.style.display = "none";
  $(".hs-popup-cart-sp-load").addClass("hs-active");
}
function onClickFilter(image) {
  // Neutralized - variant navigation & sliding is handled centrally in assets/variants.js
}